import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "phoneField",
    "imageField",
    "bannerField",
    "titleField",
    "descField",
    "primaryBtnField",
    "secondaryBtnField"
  ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const styleSelect = this.element.querySelector('select[name="widget[widget_style_id]"]')
    if (!styleSelect) return

    const selectedOption = styleSelect.options[styleSelect.selectedIndex]
    const styleId = selectedOption.value

    if (!styleId) return

    fetch(`/admin/widget_styles/${styleId}`)
      .then(response => response.json())
      .then(data => {
        this.toggleTarget(this.phoneFieldTarget, data.display_phone)
        this.toggleTarget(this.imageFieldTarget, data.display_image)
        this.toggleTarget(this.bannerFieldTarget, data.display_banner)
        this.toggleTarget(this.titleFieldTarget, data.display_title)
        this.toggleTarget(this.descFieldTarget, data.display_desc)
        this.toggleTarget(this.primaryBtnFieldTarget, data.display_primary_btn)
        this.toggleTarget(this.secondaryBtnFieldTarget, data.display_secondary_btn)
      })
      .catch(error => console.error("Error fetching widget style:", error))
  }

  toggleTarget(target, show) {
    if (target) {
      target.classList.toggle('hidden', !show)
    }
  }

  styleChanged() {
    this.toggleFields()
  }
}
